import React, { useEffect, useRef, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import styles from './ArenaLoadingOverlay.module.css';


const ArenaLoadingOverlay = ({
  msg,
  simulate = true,
  animationSpeed = 400,
  minLoadTime = 300,
  onComplete
}) => {
  const [progress, setProgress] = useState(0);
  const startTime = useRef(Date.now());

  useEffect(() => {
    let interval = null;

    if (simulate) {
      interval = setInterval(() => {
        setProgress((prev) => {
          const elapsed = Date.now() - startTime.current;
          const canFinish = elapsed > minLoadTime;
          const safeProgress = Math.min(prev, 99.5);

          if (canFinish && safeProgress >= 95) {
            return 100;
          }

          if (safeProgress < 95) {
            const bump = safeProgress < 70 ? 1 + Math.random() * 1.5 : 0.3 + Math.random() * 0.2;
            return Math.min(safeProgress + bump + 50, 100);
          }

          return safeProgress;
        });
      }, 400);
    }

    return () => clearInterval(interval);
  }, [simulate, minLoadTime]);

  useEffect(() => {
    if (progress >= 100 && onComplete) {
      const timeout = setTimeout(() => {
        onComplete();
      }, animationSpeed + 200);
      return () => clearTimeout(timeout);
    }
  }, [progress, animationSpeed, onComplete]);

  return (
    <div className={styles.overlay}>
      <div className={styles.messageBox}>
        <p className={styles.message}>{msg}</p>
        <div className={styles.progressBar}>
          <div
            className={styles.progress}
            style={{
              width: `${Math.floor(progress)}%`,
              transition: `width ${animationSpeed}ms ease-in-out`
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ArenaLoadingOverlay;


const ArenaLoadingOverlayy = ({msg, onComplete }) => {
  const controls = useAnimation();

  useEffect(() => {
    if(controls === undefined) return;
	const sequence = async () => {
      await controls.start({ width: '30%' });
      await controls.start({ width: '70%', transition: { duration: 1.2 } });
      await controls.start({ width: '100%', transition: { duration: 0.6 } });
      setTimeout(onComplete, 300); // small delay to let the bar finish
    };
	
	//setTimeout(() => { sequence();}, 10);
   
  }, []);

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <h1>{msg}</h1>
        <div className={styles.progressWrapper}>
          <motion.div
            className={styles.progress}
            initial={{ width: 0 }}
            animate={controls}
          />
        </div>
      </div>
    </div>
  );
};

//export default ArenaLoadingOverlay;
